import { Booking } from './Booking';

window.addEventListener('DOMContentLoaded', initializeBooking);

function initializeBooking() {
  const bookingBars = document.querySelectorAll('.booking-bar');

  if (bookingBars) {
    bookingBars.forEach((bar) => new Booking(bar));
  }
}
